<div *ngIf="accessdenied" class="row">
    <div class="col-md-12 no-padding">
        <app-access-denied></app-access-denied>
    </div>
</div>
<div *ngIf="!accessdenied" class="row">
    <div class="col-md-8 no-padding">
        <div class="row" style="margin-bottom: 15px;">
            <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; ">
                <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                    <span style="float:left">Discussion #{{discussion.discussionId}}</span>
                    <span style="float:right">{{discussion.createdDate | date:'medium'}}</span>
                </h6>
            </div>
            <div class="col-xl-12 block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">
                <div class="row">
                    <div class="col-md-10 col-sm-10 col-xs-10 no-padding" style="margin-bottom: 10px;">
                        <span class="box-category">{{discussion.category}}</span>
                    </div>
                    <div class="col-md-1 col-sm-1 col-xs-1 no-padding">
                        <i class="fa fa-eye"></i><span> {{discussion.viewsCount}}</span>
                    </div>
                    <div class="col-md-1 col-sm-1 col-xs-1 no-padding">
                        <i class="fa fa-comment"></i><span> {{answers.length}}</span>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-10 col-sm-10 col-xs-10  no-padding ">
                        <h4 style=" font-size: 1.5rem;"> {{discussion.title}}</h4>
                    </div>
                    <!--BookMark-->
                    <div style="margin: auto;cursor:pointer" *ngIf="showFollowBlock && !isFollow" (click)="followDiscussion()" class="col-md-2 col-sm-2 col-xs-2  no-padding tag">
                        <span>Follow</span>
                    </div>
                    <div style="margin: auto;cursor:pointer" *ngIf="showFollowBlock && isFollow" (click)="unfollowDiscussion()" class="col-md-2 col-sm-2 col-xs-2  no-padding tagFilled">
                        <span>Unfollow</span>
                    </div>
                </div>
                <div class="row" style="padding-left: 15px; padding-top: 15px;">
                    <div class="col-md-1 col-sm-1 col-xs-1" style="    padding: 0px !important; font-size: 22px !important; color: lightgrey;">
                        <!--<div style="height: 40px; width: 40px; border-radius:50%" class="postContactLogo default-bg" [ngStyle]="{'background-image': 'url(' + discussion.owner.contactLogo + ')'}"></div>-->
                        <img class="b-r-10 profileImg" [src]="discussion.owner.contactLogo" alt="">
                    </div>
                    <div class="col-md-11 col-sm-11 col-xs-11" style="    padding: 0px !important; font-size: 20px !important;">
                        <small style="color:#00A6B6;"> {{discussion.owner.firstName}} {{discussion.owner.lastName}}</small><br />
                        <small style="opacity:.5" class="feed-time-date">
                            <span *ngIf="discussion.owner.title != ''  ">{{discussion.owner.title}}</span>
                            <span *ngIf="discussion.owner.portalAccount.name  != '' && discussion.owner.title  != ''  "> , </span>
                            <span *ngIf="discussion.owner.portalAccount.name  != ''  ">{{discussion.owner.portalAccount.name}}</span>
                        </small>
                    </div>
                </div>

                <div class="row" style="padding-top:15px">
                    <div id="q_description" class="col-md-12" [innerHTML]="discussion.description">
                    </div>
                </div>

                <div class="row" style="padding-top:15px">
                    <div class="col-md-12 col-sm-12 col-xs-12  no-padding">
                        <span style="color:#00A6B6;"><b>Tags </b></span>
                    </div>
                    <div class="col-md-12 col-sm-12 col-xs-12  no-padding">
                        <div class="row" style="    padding-top: 10px;">
                            <div style="margin-left:5px;margin-bottom:5px" class="col-md-3 col-sm-3 col-xs-3  no-padding tag" *ngFor="let item of discussionTags ">
                                <span>{{item.discussionTag.tagName}}</span>
                            </div>
                        </div>
                    </div>

                </div>


            </div>


            <div class="col-xs-12 col-sm-12 col-lg-12 largTextbox no-padding" style="box-shadow: 0 2px 6px 0 hsl(0deg 0% 0% / 20%); background-color: #00a6b6; color: white; border-top-right-radius: 5px; border-top-left-radius: 5px; margin-top:20px">
                <h6 style="font-size: 14px; height: 35px; margin: 0px; padding: 10px; border-top-left-radius: 5px; border-top-right-radius: 5px;" class="sub-title">
                    <span style="float:left">Discussion answers</span>
                </h6>
            </div>

            <div class="col-xl-12 block-style" style="border-top-left-radius: 0; border-top-right-radius: 0;">

                <div class="col-md-12 col-sm-12 col-xs-12  no-padding" style="margin-top:10px">
                    <div class="col-md-12 col-sm-12 no-padding">
                        <div *ngIf="answers.length > 0" class="col-md-12 col-sm-12 col-xs-12  no-padding">
                            <mat-accordion class="example-headers-align" [multi]="true">
                                <mat-expansion-panel [expanded]="true" style="margin-bottom:10px;" *ngFor="let item of answers | orderBy: 'createdDate' : false; let i = index">
                                    <mat-expansion-panel-header>
                                        <mat-panel-title>
                                            <div class="col-md-12 col-sm-12 col-xs-12 no-padding">
                                                <img style="width:30px;height:30px;border-radius:50%" class="message-avatar" src="{{item.owner.contactLogo}}" alt="">
                                                <a style="padding-left:5px; font-size:14px;color:#00A6B6;"> {{item.owner.firstName}} {{item.owner.lastName}} </a>
                                                <small style="float: right; opacity:.5">
                                                    <span *ngIf="item.isBestAnswer" class="best-answer" style="padding-left:10px; padding-right:10px; color:green"><i class="fa fa-check"></i></span>
                                                    {{item.createdDate | date:'medium'}}
                                                </small>
                                            </div>

                                        </mat-panel-title>
                                    </mat-expansion-panel-header>

                                    <div>
                                        <div class="discussionDetail" style="background-color: transparent;font-size:14px !important; color:#252525" [innerHTML]="item.answer"></div>
                                        <div style="margin-top:15px">
                                            <span *ngIf="ShowMarkRemoveBestAnswer && !item.isBestAnswer" style="padding: 10px;cursor:pointer">
                                                <a (click)="isBestAnswer(item)" style="color:green"> Mark as Best Answer </a>
                                            </span>
                                            <span *ngIf="ShowMarkRemoveBestAnswer && item.isBestAnswer" style="padding: 10px;cursor:pointer">
                                                <a (click)="removeBestAnswer(item)" style="color:red"><span class="fa fa-times"></span> Remove Best Answer  </a>
                                            </span>
                                        </div>


                                    </div>

                                </mat-expansion-panel>

                            </mat-accordion>
                        </div>
                        <div *ngIf="answers.length == 0" class="col-md-12 col-sm-12 col-xs-12  no-padding">
                            No answers found
                        </div>
                        <div class="col-md-12 col-sm-12 col-xs-12 no-padding">
                            <!--<textarea placeholder="Write your message here..." style="padding:10px !important;    font-size: 14px !important; margin-bottom: 10px;   border-color: lightgrey;border-bottom: 2px solid #00A6B6;width:100%;height:100px" class="summernote" [(ngModel)]="activityHistory.Description"></textarea>-->
                            <quill-editor [(ngModel)]="myAnswer" [styles]="{height: '200px'}" placeholder="Leave your answer here..."></quill-editor>


                            <div class="col-md-12" style="padding-top:5px; text-align: right; ">
                                <button style="float:right" [disabled]="btnSendDisabled" class="btn mygistec-main-btn" (click)="onSubmitAnswer()">{{btnSubmitText}}</button>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>




    </div>
    <div class="col-md-4" style="padding-right: 0px; padding-left: 30px;">
        <app-discussions-box [relatedDiscussionId]="id" [isRelatedDiscussions]="true" [title]="'Related discussions'"></app-discussions-box>
    </div>
</div>
